import React from "react";
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./LinkButton.scss";

export const LinkButton = ({ href, isExternal, text, styles, ...rest }) => {
	const { t } = useTranslation();

	if (isExternal) {
		return (
			<a
				className={`link ${styles ? styles : ''}`}
				href={href}
				target="_blank"
				rel="noopener noreferrer"
				{...rest}
			>
				{t(text)}
				<span className="sr-only"> ({t("alt.opensNewTab")})</span>
			</a>
		);
	}

	return (
		<Link className={`link ${styles ? styles : ''}`} to={href} {...rest}>{t(text)}</Link>
	);
};

LinkButton.defaultProps = {
	isExternal: false
};

LinkButton.propTypes = {
	href: PropTypes.string.isRequired,
	isExternal: PropTypes.bool, 
	styles: PropTypes.string,
	text: PropTypes.string.isRequired,
}

export default LinkButton;
